export default class Accordion {
    constructor() {
        if (!$('.accordion').length) {
            return false;
        }
        this.items = [];
        this.current = null;
        this.toggleItem = this.toggleItem.bind(this);
        this.init();
    }

    init() {
        const context = this;
        let i = 0;
        let openByParam = this.getUrlParameter("tickettemplate");
        $('.accordion').each(function () {
            i++
            let item = new AccordionItem($(this), context.toggleItem);
            context.items.push(item);

            if (item.el.hasClass('initially-collapsed')) {
                item.close();
            } else if (item.el.hasClass('initially-expanded')) {
                context.current = item;
            } else {
                if (!isNaN(openByParam)) {                     
                    if (item.tickettemplateid !== openByParam) item.toggle();
                    if (item.open) {
                        context.current = item;
                    }
                } else {
                    if (i !== 1) item.toggle();
                    if (item.open) {
                        context.current = item;
                    }
                }
            }
        });
    }

    toggleItem(item) {

        if (item.el.hasClass('closes-others')) {
            if (this.current && this.current !== item) {
                this.current.close();
            }
        }

        item.toggle();
        this.current = item;
    }

    getUrlParameter(sParam) {
        var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
    };

}

class AccordionItem {
    constructor(el, cb) {
        this.el = el;
        this.cb = cb;

        this.content = this.el.parent().find('.content');
        this.arrow = this.el.find('.toggle img');
        this.tickettemplateid = this.el.parent().parent().attr("data-template");
        
        this.open = this.content.hasClass('collapsed') ? false : true;
        this.init();
    }

    init() {
        this.el.on('click', () => {
            this.cb(this);
        });
        if (this.open) {
            this._notifyChange();
        }
    }

    toggle() {
        this.open ? this.content.addClass('collapsed') && this.arrow.removeClass('open') : this.content.removeClass('collapsed') && this.arrow.addClass('open');
        this.open = !this.open;
        this._notifyChange();
    }

    close() {
        this.open = false;
        this.content.addClass('collapsed');
        this.arrow.removeClass('open');
    }

    _notifyChange() {
        $(window).trigger('accordion.change', this.el);
    }
}
